import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAYS_IN = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Dates the member knows can be hard (anniversaries etc.), used by the forecast
export const HardDates = ({ dates, onChange, trigger }) => {
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [label, setLabel] = useState("");
  const add = async () => {
    if (!month || !day || !label.trim()) return;
    try { await api.post("/forecast/dates", { md: `${month}-${day}`, label }); setMonth(""); setDay(""); setLabel(""); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (id) => { await api.delete(`/forecast/dates/${id}`); onChange(); };
  return (
    <Dialog>
      <DialogTrigger asChild><button data-testid="forecast-hard-dates-btn">{trigger}</button></DialogTrigger>
      <DialogContent data-testid="forecast-hard-dates-dialog">
        <DialogHeader><DialogTitle>Dates that can be hard</DialogTitle></DialogHeader>
        <p className="text-sm text-mm-muted">Anniversaries or other dates that tend to weigh on you. The forecast will gently flag them each year. Only you can see these.</p>
        <div className="space-y-2">
          {dates.map((d) => (
            <div key={d.id} className="flex items-center justify-between mm-soft px-3 py-2 text-sm" data-testid={`forecast-hard-date-${d.id}`}>
              <span><b>{new Date(`2000-${d.md}T12:00:00`).toLocaleDateString(undefined, { month: "long", day: "numeric" })}</b> · {d.label}</span>
              <button onClick={() => remove(d.id)} aria-label="Remove date" data-testid={`forecast-hard-date-remove-${d.id}`}><X size={15} /></button>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          <select value={month} onChange={(e) => setMonth(e.target.value)} className="mm-input flex-1 min-w-[8rem]" aria-label="Month" data-testid="forecast-hard-date-month">
            <option value="">Month</option>
            {MONTHS.map((m, i) => <option key={m} value={String(i + 1).padStart(2, "0")}>{m}</option>)}
          </select>
          <select value={day} onChange={(e) => setDay(e.target.value)} className="mm-input w-24" aria-label="Day" data-testid="forecast-hard-date-day">
            <option value="">Day</option>
            {Array.from({ length: month ? DAYS_IN[Number(month) - 1] : 31 }, (_, i) => String(i + 1).padStart(2, "0")).map((d) => <option key={d} value={d}>{Number(d)}</option>)}
          </select>
          <input value={label} onChange={(e) => setLabel(e.target.value.slice(0, 60))} placeholder="e.g. Dad's anniversary" className="mm-input flex-[2] min-w-[10rem]" data-testid="forecast-hard-date-label" />
          <button onClick={add} className="mm-btn" data-testid="forecast-hard-date-add">Add</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
